import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import useAuthContext from './useAuthContext';
import { useEffect } from 'react';


const useLogout = () => {
  const { dispatcher } = useAuthContext();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  
  useEffect(() => {
    const leadId = localStorage.getItem('leadId');
  }, []);
  
  
  const logout = async () => {
    await queryClient.removeQueries();
    dispatcher({
      type: 'LOGOUT',
    });
    
    const leadId = localStorage.getItem('leadId');
  
    if (leadId) {
      localStorage.setItem('leadId', leadId);
    }
  
    localStorage.removeItem('mm:user');
    localStorage.removeItem('metamodel_token');
    sessionStorage.clear();
    navigate('/login');
  };
  return { logout };
};

export default useLogout;
